import { render, staticRenderFns } from "./AppNavigationList.vue?vue&type=template&id=395623e4&"
import script from "./AppNavigationList.vue?vue&type=script&lang=js&"
export * from "./AppNavigationList.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports